import React from 'react';
import moment from 'moment';

/**
 * Picking receipt for a confirmed Markt reservation, so the logistics team can
 * pick the reserved goods from the warehouse. Articles + quantities only, no
 * prices. Hidden on screen; a print stylesheet hides everything else on the
 * page and shows just this block, sized for an 80mm thermal printer. Mirrors the
 * POS receipt styling (see pages/Markt/sell/PickingReceipt.js). Printing is
 * triggered by the parent via window.print().
 */
const ReservationPickingReceipt = ({ reservation }) => {
  return (
    <div className='picking-receipt' aria-hidden='true'>
      <style>{`
        .picking-receipt { display: none; }
        @media print {
          @page { size: 80mm auto; margin: 3mm; }
          body * { visibility: hidden !important; }
          .picking-receipt, .picking-receipt * { visibility: visible !important; }
          .picking-receipt {
            display: block !important;
            position: absolute; left: 0; top: 0; width: 72mm;
            /* Heavy sans-serif renders far darker on a 180dpi thermal head
               than a thin monospace like Courier. */
            font-family: Arial, Helvetica, sans-serif;
            color: #000 !important;
            font-weight: 700;
            line-height: 1.25;
            /* Stop the browser from lightening/greying the print. */
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .picking-receipt h2 { font-size: 26px; font-weight: 900; margin: 0 0 8px; line-height: 1.15; }
          .picking-receipt .meta { font-size: 18px; font-weight: 700; }
          .picking-receipt table { width: 100%; border-collapse: collapse; margin-top: 6px; }
          .picking-receipt td { padding: 6px 0; font-size: 24px; font-weight: 700; vertical-align: top; }
          .picking-receipt td.qty { font-size: 30px; font-weight: 900; white-space: nowrap; padding-right: 12px; }
          .picking-receipt hr { border: none; border-top: 2px solid #000; margin: 8px 0; }
          .picking-receipt .foot { font-size: 18px; font-weight: 700; margin-top: 10px; }
        }
      `}</style>
      {reservation && (
        <div>
          <h2>ABHOLBELEG</h2>
          <h3>[G]etränkemar[K]t</h3>
          <div className='meta'>Reservierung: {String(reservation.id).slice(0, 8)}</div>
          <div className='meta'>Kunde: {reservation.customer_name}</div>
          {reservation.pickup_until && (
            <div className='meta'>
              Abholung bis:{' '}
              {moment(reservation.pickup_until, 'YYYY-MM-DD').format('DD.MM.YYYY')}
            </div>
          )}
          <hr />
          <table>
            <tbody>
              {(reservation.items || []).map((item) => (
                <tr key={item.id}>
                  <td className='qty'>{item.quantity}×</td>
                  <td>{item.article_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr />
          {reservation.note && (
            <div className='foot'>Notiz: {reservation.note}</div>
          )}
          <div className='foot'>Bitte aus dem Lager kommissionieren.</div>
        </div>
      )}
    </div>
  );
};

export default ReservationPickingReceipt;
